// extracted by mini-css-extract-plugin
export default {"describeVideoButton":"DescribeVideoButton_describeVideoButton__EnTlq","describeVideoButtonText":"DescribeVideoButton_describeVideoButtonText__qQcCI"};